/*! @azure/msal-common v15.2.0 2025-03-04 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "15.2.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
